export default {
  laboratories: [],
  molecularMarkerToUpdate: null,
  testData: [],
  rawData:[],
  packageSelected: null,
};
